import React from 'react'
import PropTypes from 'prop-types'
import Collapse from '../collapse'
import ExpandableList from '../expandable-list'
import {
  events,
  actions,
  categories as analyticsCategories,
} from '../../../helpers/analytics-utils/constants'
import analyticsUtils from '../../../helpers/analytics-utils'
import style from './index.scss'
import analyticsHierarchy, { CATEGORY_FIELDS } from './analytics-hierarchy'

const CategoryFilter = ({
  rootPath,
  availableCategories,
  buildUrl,
  categoriesHierarchy,
}) => {
  // If there are no available categories, i.e. we're at sub category 2, don't
  // show the category filter
  if (availableCategories.length === 0) {
    return ''
  }

  const parsedCategoryFields = analyticsHierarchy(categoriesHierarchy)

  // Note: Always go back to the first page when switching category
  const mapCategory = (category, addNext) => {
    const nextCategory =
      CATEGORY_FIELDS[Object.keys(parsedCategoryFields).length]
    return Object.assign({}, category, {
      link: buildUrl({ categoryPath: category.path }),
      value: category.name || category.value,
      onClick: () =>
        analyticsUtils.gaTagTracking(
          Object.assign(
            {
              event: events.SELECT_CATEGORY,
              eventCategory: analyticsCategories.CATEGORY_SELECTION,
              eventAction: actions.SELECT_CATEGORY_FROM_FILTER,
            },
            parsedCategoryFields,
            addNext ? { [nextCategory]: category.value } : {}
          )
        ),
    })
  }

  const categories = availableCategories.map(c => mapCategory(c, true))

  const rootCategory = mapCategory(
    availableCategories[0] ||
      categoriesHierarchy[0] || {
        path: rootPath,
        value: 'Products',
      },
    false
  )
  // Add a category at the top that shows all items
  const modifiedFirstElement = Object.assign({}, rootCategory)
  modifiedFirstElement.value = `All ${modifiedFirstElement.value ||
    modifiedFirstElement.name}`

  const updatedCategories = [modifiedFirstElement].concat(
    categories.filter(category => category.path !== rootCategory.path)
  )

  return (
    <Collapse
      isExpanded
      heading={rootCategory.value}
      className={style.collapse}
      trackToggle={false}
    >
      <ExpandableList
        items={updatedCategories}
        size={7}
        analyticsEvent={events.SELECT_CATEGORY}
        analyticsEventAction={actions.SELECT_CATEGORY_FROM_FILTER}
        analyticsEventCategory={analyticsCategories.CATEGORY_SELECTION}
      />
    </Collapse>
  )
}

CategoryFilter.propTypes = {
  rootPath: PropTypes.string.isRequired,
  availableCategories: PropTypes.arrayOf(PropTypes.object).isRequired,
  buildUrl: PropTypes.func.isRequired,
  categoriesHierarchy: PropTypes.array.isRequired,
}

export default CategoryFilter
